import React from "react";
import { Popover } from "antd";
import { QuestionCircleFilled } from "@ant-design/icons";

interface Props {
  title: string;
  content: React.ReactNode;
}

export const Note = (props: Props) => {
  return (
    <Popover title={props.title} content={props.content} trigger="click">
      {" "}
      <QuestionCircleFilled />{" "}
    </Popover>
  );
};

export default Note;
